import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import DropDown from '../../../../components/Input/DropDown'
import ErrorMessageWithExclamation from '../../../../components/UI/ErrorMessageWithExclamation'
import { Button } from '../../../../components/UI'
import Radio from '../../../../components/UI/Radio'

import { selectUserData } from '../../../../routing/fetchingfunction/user/user.reducer'
import { setStep, updateAbout } from '../../../../routing/fetchingfunction/user/user.action'

import { useGetInfo } from '../../../../hooks'

import { TimeScheme } from '../../../../routing/utils/validators'

import { compareTimeZones } from '../../../../helpers'

import { dateFormats } from '../../../../constants'

const Time = () => {
  const dispatch = useDispatch()

  const userData = useSelector(selectUserData)

  const {
    formState: { errors },
    handleSubmit,
    register,
    control,
  } = useForm({
    defaultValues: {
      time_format: userData?.profile?.time_format,
      timezone: userData?.profile?.timezone,
      date_format: userData?.profile?.date_format,
    },
    resolver: yupResolver(TimeScheme),
  })

  const { formattedWorldTimezones } = useGetInfo()

  const [isLoading, setIsLoading] = useState(false)

  const handleFormSubmit = (data) => {
    setIsLoading(true)

    dispatch(
      updateAbout({
        id: userData.id || userData.pk,
        profile: {
          ...userData.profile,
          ...data,
        },
      })
    )
      .then((data) => {
        if (!data.error) {
          dispatch(setStep(1))
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div className="w-full mt-[20px] bg-[#FEEBDD] rounded-[10px] p-[32px]">
      <h4 className="text-base font-bold text-primary-100">Time</h4>

      <h5 className="mt-[8px] text-sm font-normal text-primary-100">
        Make sure to add accurate time so there are no scheduling issues.
      </h5>

      <form
        className="
    w-full
    flex flex-col items-start
    mt-[20px]
    rounded-[10px]
    gap-y-[20px]
    border-[1px] border-[#FFCA84]
    p-[20px]
    max-w-full
    sm:max-w-full
    mx-auto
  "
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <div className="w-full max-w-full sm:max-w-[463px]">
          {' '}
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            Time Format
          </span>
          <div className="w-full flex flex-col sm:flex-row gap-[12px]">
            <label className="sm:flex-1 cursor-pointer h-[44px] px-[14px] shadow-button rounded-[8px] border-[#FFCA84] border-[1px] bg-white flex items-center w-full">
              <Radio value="12" {...register('time_format')} />

              <span className="text-base font-normal text-primary-100 ml-[8px] select-none">
                12-hour
              </span>
            </label>

            <label className="sm:flex-1 cursor-pointer h-[44px] px-[14px] shadow-button rounded-[8px] border-[#FFCA84] border-[1px] bg-white flex items-center w-full">
              <Radio value="24" {...register('time_format')} />

              <span className="text-base font-normal text-primary-100 ml-[8px] select-none">
                24-hour
              </span>
            </label>
          </div>
          {errors.time_format && <ErrorMessageWithExclamation text={errors.time_format.message} />}
        </div>

        <div className="w-full max-w-full sm:max-w-[463px]">
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            Time Zone
          </span>

          <Controller
            control={control}
            name="timezone"
            render={({ field: { value, onChange } }) => {
              return (
                <DropDown
                  menuItems={formattedWorldTimezones.sort(compareTimeZones)}
                  placeholder="Select Time Zone"
                  value={value}
                  setValue={onChange}
                />
              )
            }}
          />

          {errors.timezone && <ErrorMessageWithExclamation text={errors.timezone.message} />}
        </div>

        <div className="w-full max-w-full sm:max-w-[463px]">
          {' '}
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            Date Format
          </span>
          <Controller
            control={control}
            name="date_format"
            render={({ field: { value, onChange } }) => {
              return (
                <DropDown
                  menuItems={dateFormats}
                  placeholder="Select Date Format"
                  value={value}
                  setValue={onChange}
                />
              )
            }}
          />
        </div>

        <Button
          type="submit"
          className="!text-sm !font-semibold min-w-[129px]"
          isLoading={isLoading}
        >
          Save Changes
        </Button>
      </form>
    </div>
  )
}

export default Time
